import http from './http';

const httpGet = async (url, params = undefined, config = undefined) => {
  const response = await http.get(url, { ...config, params });
  return response.data;
};

export default httpGet;
